import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Layout, Radio } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 bg-bg-primary" data-id="element-114">
      <div className="container max-w-4xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-6" data-id="element-117">
            Por qué la mayoría falla{' '}
            <span className="text-text-secondary block text-2xl mt-2" data-id="element-118">
              (y por qué esto sí funciona)
            </span>
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-119">
            La mayoría busca "trucos". Pero la atracción sostenida se construye
            con 3 palancas. Si una falla, se siente.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-120">
          {[{
          icon: Zap,
          title: 'Energía',
          desc: 'cómo llegás (necesidad vs calma)',
          color: 'text-yellow-400'
        }, {
          icon: Layout,
          title: 'Estructura',
          desc: 'qué hacés (intención, límites, dirección)',
          color: 'text-blue-400'
        }, {
          icon: Radio,
          title: 'Señales',
          desc: 'qué transmitís (seguridad, claridad, congruencia)',
          color: 'text-green-400'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex items-center p-6 bg-bg-card border border-border-color rounded-xl" data-id="element-121">
              <div className={`w-12 h-12 rounded-full bg-bg-primary flex items-center justify-center mr-6 border border-border-color ${item.color}`} data-id="element-122">
                <item.icon className="w-6 h-6" data-id="element-123" />
              </div>
              <div data-id="element-124">
                <h3 className="text-xl font-bold text-text-primary" data-id="element-125">
                  {item.title}
                </h3>
                <p className="text-text-secondary" data-id="element-126">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 p-6 bg-accent/10 border border-accent/20 rounded-xl text-center" data-id="element-127">
          <p className="text-text-primary font-medium" data-id="element-128">
            El Método Magnético te guía por esas 3 palancas con un plan práctico
            y medible.
          </p>
        </motion.div>
      </div>
    </section>;
}